import { Injectable } from '@angular/core'
import { Action, select, Store } from '@ngrx/store'
import { GbBaseFacade } from 'libs/shared/data-access-core/src/lib/+state/gb-base-facade-interface'
import { FavouriteItemsState } from './favourite-items.reducer'
import * as FavouriteItemsSelectors from './favourite-items.selectors'

@Injectable({
  providedIn: 'root',
})
export class FavouriteItemsFacade implements GbBaseFacade {
  loaded$ = this.store.pipe(select(FavouriteItemsSelectors.getFavouriteItemsLoaded))
  allFavouriteItems$ = this.store.pipe(select(FavouriteItemsSelectors.getAllFavouriteItems))
  allFavouriteItemIds$ = this.store.pipe(select(FavouriteItemsSelectors.getAllFavouriteItemIds))
  count$ = this.store.pipe(select(FavouriteItemsSelectors.getFavouriteItemsCount))
  order$ = this.store.pipe(select(FavouriteItemsSelectors.getFavouriteItemsOrder))
  stalePages$ = this.store.select(FavouriteItemsSelectors.getFavouriteItemsStalePages)
  enableFavourite$ = this.store.pipe(select(FavouriteItemsSelectors.getEnableFavourite))

  constructor(private store: Store<FavouriteItemsState>) {}

  dispatch(action: Action): void {
    this.store.dispatch(action)
  }
}
